import { User } from "../../types";
import UserService from "../../services/User";

import { QUERY_KEY } from "./useListUsers";
import useAuthorizedQuery from "../../common/hooks/useAuthorizedQuery";

export const makeQueryKey = (id?: User["id"]) => [QUERY_KEY, id];

function useFetchUser(id?: User["id"]) {
  const key = makeQueryKey(id);

  return useAuthorizedQuery(
    key,
    () => {
      if (id) {
        return UserService.fetchUser(id);
      }

      throw new Error("user id is required");
    },
    { enabled: !!id }
  );
}

export default useFetchUser;
